import type { ResolutionEvent } from "../../domain/types/index.js";
import { generatedHappeningArt, spriteHappeningArt } from "./happeningArtMaps.js";
import { LoadChanges } from "./LoadChanges.js";

const STAGGER_MS = 350;

type StageEvent = Extract<ResolutionEvent, { kind: "load" | "overdue" }>;

function HappeningArt({ event }: { event: Extract<ResolutionEvent, { kind: "load" }> }) {
  const sprite = spriteHappeningArt(event.loadId);
  if (sprite) {
    return <div className={`happening-art is-${sprite}`} role="img" aria-label={`${event.loadName}の絵札`} />;
  }
  const source = generatedHappeningArt(event.loadId);
  if (!source) return null;
  return <img className="happening-art" src={source} alt={`${event.loadName}の絵札`} />;
}

function titleOf(event: StageEvent): string {
  return event.kind === "load" ? event.loadName : "納期超過";
}

export function HappeningStage({ event }: { event: StageEvent }) {
  return (
    <div className="happening-stage-backdrop">
      <section
        className={`happening-stage${event.kind === "load" || event.kind === "overdue" ? " is-threat" : ""}`}
        aria-label="ハプニング"
        aria-live="polite"
      >
        <span className="event-source">{event.kind === "load" ? "ハプニング" : "フェーズ解決"}</span>
        <div className="happening-stage-body">
          {event.kind === "load" && <HappeningArt event={event} />}
          <div className="happening-stage-text">
            <p className="event-kicker">{titleOf(event)}</p>
            {event.kind === "load" && <LoadChanges event={event} staggerMs={STAGGER_MS} />}
          </div>
        </div>
      </section>
    </div>
  );
}
